import { useQueries, UseQueryOptions } from '@tanstack/react-query'

import { IProductResponse } from 'src/@interfaces'
import { queryConfig, QUERY_DATA } from 'src/service'

import { useMagazineContext } from '../useMagazineContext'
import { useReseller } from '../useReseller/useReseller'
import { IOrderBy } from './types'
import { getProductsFetcher } from './utils'

export type UseProductsQueriesParams = {
  products: string[]
  pageSize?: number
  orderBy?: IOrderBy
}

/**
 * Hook para buscar múltiplos conjuntos de produtos com base em diferentes SKUs.
 * Útil para vitrines dinâmicas ou seções de produtos que requerem várias consultas.
 */
export const useProductsQueries = (queries: UseProductsQueriesParams[]) => {
  const { data: reseller, isGenericUser } = useReseller()
  const magazine = useMagazineContext()

  return useQueries({
    queries: queries.map(
      (queryParams): UseQueryOptions<IProductResponse> => ({
        ...queryConfig,
        queryKey: [QUERY_DATA.PRODUCTS, queryParams.products],
        queryFn: ({ signal }) =>
          getProductsFetcher(
            {
              products: queryParams.products,
              orderBy: queryParams.orderBy,
              reseller,
              isGenericUser,
              magazine,
              pageSize: queryParams.pageSize,
            },
            { signal },
          ),
        enabled: Boolean(queryParams.products.length),
      }),
    ),
  })
}
